import { Box } from '@wix/design-system';
import React, { FunctionComponent, useContext } from 'react';

import { LoggedIn } from './LoggedIn';
import { NotLoggedIn } from './NotLoggedIn';
import { SearchBarModal } from './SearchBarModal';
import { Context } from '../../../context';
import useIsHelpCenterSearchResultV2Enabled from '../../../hooks/useIsHelpCenterSearchResultV2Enabled';
import { useIxWixelRelated } from '../../../hooks/useIsWixelRelated';
import { PageType } from '../../../types';
import { useStore } from '../../../zustand/stores';

export const HeaderRight: FunctionComponent = () => {
  const { user } = useStore((state) => state.userSlice);
  const { pageType } = useContext(Context);
  const isHelpCenterSearchResultV2Enabled = useIsHelpCenterSearchResultV2Enabled();
  const shouldHideSearchBar = useIxWixelRelated() ||
    (isHelpCenterSearchResultV2Enabled && pageType === PageType.SearchResults);

  return (
    <Box gap={2}>
      {!shouldHideSearchBar && <SearchBarModal />}
      {user === null ? <NotLoggedIn /> : <LoggedIn />}
    </Box>
  );
};
